import { HStack } from '@rbilabs/universal-components';

export const RewardRow = HStack.withConfig({
  _text: {
    color: Styles.color.validated,
  },
});
